import { Route } from '@solidjs/router'
import Layout from '@/layout'
import StuffView from '@/views'
import ItemsView from '@/views/items'
import ItemsDetailView from '@/views/items/[itemId]'
import TablesView from './views/tables'
import TablesDetailView from './views/tables/[tableId]'
import MediaView from './views/media'
import MediaDetailView from './views/media/[mediaId]'

function App() {
  return (
    <Route path={'/'} component={Layout}>
      <Route path={'/'} component={StuffView} />
      <Route path={'/items'} component={ItemsView} />
      <Route path={'/items/:id'} component={ItemsDetailView} />
      <Route path={'/tables'} component={TablesView} />
      <Route path={'/tables/:id'} component={TablesDetailView} />
      <Route path={'/media'} component={MediaView} />
      <Route path={'/media/:id'} component={MediaDetailView} />
    </Route>
  )
}

export default App
